/**
 * @desc 获取可退数量
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.RefundAbleQtyRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/inPlanMaster/getRefundAbleQty`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
